class Modal {
  constructor(modalBackground) {
    this.modalBackground = modalBackground;
  }

  buttonAction(openBtn, closeBtn) {
    if (openBtn !== null) {
      let that = this;

      if (openBtn.length === undefined) {
        openBtn.addEventListener("click", function () {
          that.modalBackground.style.display = "flex";
        });
      } else {
        openBtn.forEach((element) => {
          element.addEventListener("click", function () {
            that.modalBackground.style.display = "flex";
          });
        });
      }

      closeBtn.addEventListener("click", function () {
        that.modalBackground.style.display = "none";
      });
    }
  }
}

if (document.getElementById("login-modal-background") !== null) {
  const loginModal = new Modal(document.getElementById("login-modal-background"));
  loginModal.buttonAction(document.getElementById("login-modal-open"), document.getElementById("login-modal-close"));
}